export type ListingCategory = 'store' | 'offer' | 'auction';

export function resolveListingCategory(item: any): ListingCategory {
    if (!item) return 'store';
    const rawType = String(
        item.listing_type || item.type || item.sale_type || item.status || item.listing_data?.type || ''
    ).toLowerCase();

    if (
        rawType === 'auction' ||
        rawType === 'username_auction' ||
        rawType === 'auctioned' ||
        item.isAuction === true ||
        (item.start_price != null && item.ends_at != null)
    ) {
        return 'auction';
    }

    if (
        rawType === 'offer' ||
        rawType === 'offers' ||
        rawType === 'username_offer' ||
        item.isOffer === true
    ) {
        return 'offer';
    }

    return 'store';
}
